import React from "react";
import { Link } from "react-router-dom";
import { Divider, Row, Col, Tooltip, Modal } from "antd";
import { Logout } from "react-iconly";
import store from '../../../../redux/store';
import * as actions from "../../../../redux/Login/LoginTypes";
import { UserLogout } from '../../../../redux/Login/LoginActions';

export default function MenuFooter(props) {

  const handleLogout = () => {
    Modal.confirm({
      title: "Do you want to logout?",
      onOk() {
        setTimeout(() => {
          store.dispatch({ type: actions.LOGOUT });
          store.dispatch(UserLogout());
        }, 200);
      }
    })
  }

  const getNameIcon = (text) => {
    var str = text;
    if (str) {
      var matches = str.match(/\b(\w)/g);
      if (matches != null) {
        var acronym = matches.join('');

        return acronym.length >= 2 ? acronym.substring(0, 2).toUpperCase() : acronym.toUpperCase();
      }
    }
    return text.toUpperCase();
  }

  return (
    props.collapsed === false ? (
      <Row
        className="hp-sidebar-footer hp-pb-16 hp-px-16 hp-bg-color-dark-100"
        align="middle"
        justify="space-between"
      >
        <Divider className="hp-border-color-black-20 hp-border-color-dark-70 hp-mt-0" />

        <Col flex={1}>
          <div className="hp-d-flex hp-align-items-center hp-justify-content-between">
            <div>
              <Tooltip placement="right" title="My Profile"> 
                <Link to="/MyProfile">
                  <span className="ant-avatar ant-avatar-circle ant-avatar-image hp-cursor-pointer hp-mr-16" style={{ background: "#cb505b", color: "#ffffff" }}>{getNameIcon(localStorage.getItem("user"))}</span>
                </Link>
              </Tooltip>
            </div>
            <div>
              <span className="hp-d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body hp-text-uppercase" style={{overflowWrap: "anywhere"}}>
                {localStorage.getItem("user")}
              </span>
            </div>
            <div className="hp-text-right" style={{minWidth:'20px'}}>
              <Tooltip placement="top" title="Logout"><Link to="#" onClick={handleLogout} ><Logout className="remix-icon hp-text-primary hp-text-color-dark-0 hp-ml-12" size='small' /></Link></Tooltip>
            </div>
          </div>
        </Col>
      </Row>
    ) : (
      <Row className="hp-sidebar-footer hp-pt-16 hp-mb-16 hp-bg-color-dark-100" align="middle" justify="center" >
        <Col>
          <Link to="#" onClick={handleLogout} >
            <span className="ant-avatar ant-avatar-circle ant-avatar-image hp-cursor-pointer" style={{ background: "#cb505b", color: "#ffffff" }}>{getNameIcon(localStorage.getItem("user"))}</span>
          </Link>
        </Col>
      </Row>
    )
  );
};